// extracted by mini-css-extract-plugin
module.exports = {"PhotosUploadScreen":"he_a pz_cv"};